/* eslint-disable no-underscore-dangle */
/* eslint-disable no-plusplus */
import React from 'react';
import { customDateStr } from '../../../../shared/misc/utils';
import EsrrBadge from '../../EsrrBadge';
import PerformanceBadge from '../../PerformanceBadge';
import { EsrrSprTimelineRecord } from './EsrrSprTimelineRecord';

interface Props {
  record: EsrrSprTimelineRecord;
  className: string;
}

const EsrrSprTimelineItem = (props: Props) => {
  const { record, className } = props;

  return (
    <div className="esrr-spr-timeline-item">
      <div className="header">{customDateStr(record.date.toString())}</div>
      <div className={`data-container ${className}`}>
        <div className="esrr">{record.esrr ? <EsrrBadge text={record.esrr} /> : '-'}</div>
        <div className="spr">{record.spr ? <PerformanceBadge code={record.spr} /> : '-'}</div>
      </div>
    </div>
  );
};

export default EsrrSprTimelineItem;
